module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "timeline-item"
  }, [_c('svg', {
    attrs: {
      "className": "line",
      "width": "20",
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "9",
      "y": "0",
      "width": "2",
      "height": "100%"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "cx": "10",
      "cy": "10",
      "rx": "10",
      "ry": "10"
    }
  })]), _vm._v(" "), _c('p', [_vm._t("default")], 2)]), _vm._v(" "), _c('timeline-separator')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d1f9018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline/TimelineItem.vue
// module id = 294
// module chunks = 1